import {useLocation} from '@startlibs/components'

const segments = (path) => path.split('/').filter(Boolean)

/**
 * react-router-style useMatch built on the @startlibs/components facade:
 * returns { params } when the whole pathname matches, null otherwise.
 * Patterns support literal and `:param` segments only.
 */
export const matchPath = (pattern, pathname) => {
  const patternSegments = segments(pattern)
  const pathSegments = segments(pathname)
  if (patternSegments.length !== pathSegments.length) return null
  const params = {}
  for (let i = 0; i < patternSegments.length; i++) {
    const expected = patternSegments[i]
    if (expected.startsWith(':')) {
      params[expected.slice(1)] = decodeURIComponent(pathSegments[i])
    } else if (expected !== pathSegments[i]) {
      return null
    }
  }
  return {params}
}

export function useMatch(pattern) {
  const {pathname} = useLocation()
  return matchPath(pattern, pathname)
}